module.exports = __webpack_public_path__ + "static/media/balk_afm5.d95f4f3c.jpg";